import { render, staticRenderFns } from "./second-ins.vue?vue&type=template&id=47ab84de"
import script from "./second-ins.vue?vue&type=script&lang=js"
export * from "./second-ins.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports